<template>
  <!-- <div v-if="!isFilterList" style="position:sticky; top:50px;z-index:9;background:#fff"> -->
  <div v-if="!isFilterList" style="position:sticky; top:48px;z-index:9;background:#fff">
    <!-- <ul class="product_category_list flx" v-if="details.categoryFilterDTOs != 0 && this.$route.query.categoryid"> -->
    <ul class="product_category_list flx" v-if="details.categoryFilterDTOs != 0">
      <li
        v-for="(products,index) in details.categoryFilterDTOs"
        :class="getClass(products.categoryId, products.displayName)"
        class="category_card"
        :key="index"
      >
        <input type="radio" id="cat1" name="drone" value="cat1" checked />
        <label
          for="cat1"
          @click="selectCateogryOption(products.categoryId,products.displayName)"
        >{{products.displayName}}</label>
      </li>
    </ul>
    <span v-if="details.categoryFilterDTOs != null"
      @click="viewAllCat()"
     class="apply_filter"
    >{{$t('filter')}}</span>
  </div>
</template>

<script>

import "../../assets/css/category-tab.scss";
export default {
  name: "CategoryFilter",
  props: {
    dataValue: {
      required: true,
      type: Object,
      categoryFilterDTOs: {}
    },
    selectedcategoryName: {
      required: true,
      type: String
    },
    choosedCatId: {
      required: true,
      type: Number
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      selectedCategoryId: null,
      isFilterList: false,
      categories: [],
      subCategoriesDto: [],
      selectedCatName: "",
      details: {}
    };
  },
  watch: {
    dataValue() {
      this.details = this.dataValue;
      if (this.selectedcategoryName) {
        this.selectedCatName = this.selectedcategoryName;
      }
    }
  },
  methods: {
    getClass(type, name) {
      if (this.choosedCatId == type) {
         return "active";
        // if(this.$route.query.categoryid){
        //   return "active";
        // }
        
      }
    },
    selectCateogryOption(selectedCatName, displayName) {
      if (this.selectedCategoryId === selectedCatName) {
        return;
      }

      this.selectedCategoryId = selectedCatName;
      const obj = {
        categoryId: this.selectedCategoryId,
        choosedCateName: displayName
      };
      this.$emit("selectedCategory", obj);
    },
    viewAllCat() {
      this.$emit("viewAllCat");
    }
  },
  mounted() {
    this.details = this.dataValue;
    if (this.selectedcategoryName) {
      this.selectedCatNamtit = this.selectedcategoryName;
    }
  }
};
</script>
    